export const AllActionId = {
    BtnSelectCompany: "BtnSelectCompany",
    BtnReloadFiscalPeriod: "BtnReloadFiscalPeriod",
    CmbFiscalPeriodModel: "CmbFiscalPeriodModel",
    CmbAccType: "CmbAccType",
    CmbUnit: "CmbUnit",
    ChkReclass: "ChkReclass",
    BtnTransferValue: "BtnTransferValue",
    BtnTransferStructure: "BtnTransferStructure",
    BtnExportCSV: "BtnExportCSV",
    TabTransfer: "TabTransfer",
    ChkApprovalFlowStatus: "ChkApprovalFlowStatus"
}

// Default state
const AllActionDefaultState = [
    {
        Id: AllActionId.BtnSelectCompany,
        Active: true
    },
    {
        Id: AllActionId.BtnReloadFiscalPeriod,
        Active: true
    },
    {
        Id: AllActionId.CmbFiscalPeriodModel,
        Active: true
    },
    {
        Id: AllActionId.CmbAccType,
        Active: true
    },
    {
        Id: AllActionId.CmbUnit,
        Active: true
    },
    {
        Id: AllActionId.ChkReclass,
        Active: true
    },
    {
        Id: AllActionId.BtnTransferValue,
        Active: true
    },
    {
        Id: AllActionId.BtnTransferStructure,
        Active: true
    },
    {
        Id: AllActionId.BtnExportCSV,
        Active: true
    },
    {
        Id: AllActionId.TabTransfer,
        Active: true
    },
    {
        Id: AllActionId.ChkApprovalFlowStatus,
        Active: true
    }
];

export class ActionStateModel {
    constructor(obj) {
        this.AllAction = obj ? obj : AllActionDefaultState;
    }

    IsDisable(id) {
        return !this.AllAction.find(i => i.Id === id).Active;
    }

    IsActive(id) {
        return this.AllAction.find(i => i.Id === id).Active;
    }
}

/**
 * 
 * @param {*} previousState is ActionStateModel State before change
 * @returns newState
 */
export const SetActiveAll = (previousState) => {
    let newState = previousState.AllAction.map((item) => {
        item.Active = true;
        return item;
    });

    return new ActionStateModel(newState);
}

/**
 * 
 * @param {object} previousState is ActionStateModel State before change
 * @returns newState
 */
export const SetDisableAll = (previousState) => {
    let newState = previousState.AllAction.map((item) => {
        item.Active = false
        return item;
    });

    return new ActionStateModel(newState);
}

/**
 * 
 * @param {object} previousState is ActionStateModel State before change
 * @param {object} idState is Id of state control change
 * @returns 
 */
export const SetActiveById = (previousState, idState) => {
    let activeIdsState = new Map(Object.entries(idState));

    let newState = previousState.AllAction.map((item) => {
        if (activeIdsState.includes(item.Id)) {
            item.Active = true;
        }
        return item;
    });

    return new ActionStateModel(newState);
}

/**
 * 
 * @param {object} previousState is ActionStateModel State before change
 * @param {object} idState is Id of state control change
 * @returns 
 */
export const SetDisableById = (previousState, idState) => {

    let disabelIdsState = new Map(Object.entries(idState));

    let newState = previousState.AllAction.map((item) => {
        if (disabelIdsState.includes(item.Id)) {
            item.Active = false;
        }
        return item;
    });

    return new ActionStateModel(newState);
}
